module.exports = __webpack_public_path__ + "img/instagram.e531c1cb.png";